export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.7-1616.38",
  commitId: "a484b9c70f25fb674304c5821c93cf2b4e82a9c8",
  commitTime: "2026-05-07T16:16:38.000Z",
});
